module.exports = __webpack_public_path__ + "517c0f9ceea86458db23398c72ef27b9.svg";